import {
	OPERAND_TYPE_KEYWORD,
	OPERAND_TYPE_VALUE,
	OPERAND_TYPE_FUNCTION,
	OPERAND_TYPE_LIST,
	type TerminalClause,
} from '@atlaskit/jql-ast';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { IntlShape } from '@atlassian/jira-intl';
import type {
	SearchTemplate,
	SelectOption,
} from '@atlassian/jira-jql-builder-basic-picker/src/common/types.tsx';
import type { useHydratedValues$data } from '@atlassian/jira-relay/src/__generated__/useHydratedValues.graphql';
import { getFunctionValue } from '../get-function-value/index.tsx';
import { getKeywordValue } from '../get-keyword-value/index.tsx';
import { getListValue } from '../get-list-value/index.tsx';
import { getValue } from '../get-value/index.tsx';

export const getValuesFromClause = (
	terminalClause: TerminalClause,
	data: useHydratedValues$data,
	fieldJqlTerm: string,
	validOperandDisplayValues: string[] | undefined,
	intl: IntlShape,
	searchTemplate: SearchTemplate,
): SelectOption[] | SelectOption | undefined => {
	if (terminalClause.operand) {
		switch (terminalClause.operand.operandType) {
			case OPERAND_TYPE_KEYWORD: {
				return getKeywordValue(
					terminalClause.operand.value,
					validOperandDisplayValues,
					intl,
					searchTemplate,
				);
			}
			case OPERAND_TYPE_VALUE:
				return getValue(data, fieldJqlTerm, terminalClause.operand.value, intl);
			case OPERAND_TYPE_FUNCTION:
				return getFunctionValue(
					data,
					terminalClause.operand.function.value,
					validOperandDisplayValues,
					intl,
					terminalClause.operand.arguments,
					fieldJqlTerm,
				);
			case OPERAND_TYPE_LIST: {
				return getListValue({
					listOperand: terminalClause.operand,
					data,
					fieldJqlTerm,
					validOperandDisplayValues,
					intl,
					searchTemplate,
				});
			}
			default:
				throw new Error('Operand Type is not valid');
		}
	}

	log.unsafeErrorWithCustomerData(
		'jiraJqlBuilderBasic.getValuesFromClause',
		'Terminal clause operand is undefined',
		{
			jql: (
				data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter
			)?.jql,
			fieldJqlTerm,
			operator: terminalClause.operator?.value,
			searchTemplate,
		},
	);

	throw new Error('Terminal clause operand is undefined');
};
